import styled from 'styled-components';

const EditorStyle = styled.div`
	font-size: var(--p1);
	font-family: var(--montserrat_arm);
	font-weight: 400;
	line-height: var(--lineHeightL);
	color: var(--black900);
	white-space: pre-wrap;

	h5 {
		font-size: var(--h5);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		color: var(--black900);
		line-height: var(--lineHeightM);
	}

	h6 {
		font-size: var(--h6);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		color: var(--black900);
		line-height: var(--lineHeightM);
	}

	p {
		font-size: var(--p1);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeightL);
		color: var(--black900);
	}

	a {
		font-size: var(--p1);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeightL);
		color: var(--black900);
		text-decoration: underline;

		@media (hover: hover) {
			&:hover {
				text-decoration: none;
			}
		}
	}

	strong {
		font-weight: 500;
	}

	ol {
		list-style-position: inside;

		li {
			font-size: var(--p1);
			font-family: var(--montserrat_arm);
			font-weight: 400;
			line-height: var(--lineHeightL);
			color: var(--black900);
		}
	}

	ul {
		list-style: disc;
		list-style-position: inside;

		li {
			font-size: var(--p1);
			font-family: var(--montserrat_arm);
			font-weight: 400;
			line-height: var(--lineHeightL);
			color: var(--black900);
		}
	}

	blockquote {
		border-left: 3px solid var(--black900);
		padding-left: 1vw;
		font-size: var(--p1);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeightL);
		color: var(--black900);
	}

	ul > li::marker {
		font-size: var(--p1);
	}

	ul > li.bold-marker::marker,
	ol > li.bold-marker::marker {
		font-weight: 500;
	}

	ul > li.bold-marker::marker {
		font-size: var(--p1);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default EditorStyle;
